module.exports = __webpack_public_path__ + "static/media/message.39336503.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/message.svg
// module id = 1330
// module chunks = 0